export const CarsConstatns = {
  MANUFACTURER: 'manufacturer',
  MODEL_SERIES: 'modelSeries',
  FUEL_TYPE: 'fuelType',
  GEARBOX_TYPE: 'gearboxType',
  BRANCH: 'branch',
  COLOR: 'color',
  ENVIRONMENT_CLASS: 'environmentClass',
  SEGMENT: 'properties.segment',
  DRIVING_WHEEL: 'drivingWheel',
  PRICE: 'price',
  MILEAGE: 'mileage',
  ODOMETER_VALUE_AS_KM: 'odometerValueAsKm',
  MODEL_YEAR: 'modelYear',
  LEASING_PRICE: 'leasingPrice',
  // Facet ids in the public API grammar (see Gql/searchParams.ts)
  BRANCH_DISPLAY_NAME: 'branchDisplayName',
  COLOR_NAME: 'colorName',
  SEGMENT_V2: 'segment',
  DRIVETRAIN_TYPE: 'drivetrainType',
  ODOMETER: 'odometer',
  PRIVATE_LEASE: 'privateLease',
};

export const ContentConstants = {
  PAGE_TYPE: 'page_type',
};
